import { render, staticRenderFns } from "./writing.vue?vue&type=template&id=8e57ede6&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e57ede6",
  null
  
)

export default component.exports